import httpClient from "./httpClient";

const recruitmentService = {
  createCandidate(data) {
    return httpClient.post("/api/recruitment/candidate", data);
  },
  updateCandidate(uid, data) {
    return httpClient.put(`/api/recruitment/candidate?uid=${uid}`, data);
  },
  getCandidateByUid(uid) {
    return httpClient.get("/api/recruitment/candidate?uid=" + uid);
  },
  getTransportTypes() {
    return httpClient.get("/api/recruitment/candidate/transport/types");
  },
  submitCandidate(uid, data) {
    return httpClient.put(`/api/recruitment/candidate/submit?uid=${uid}`, data);
  },
  removeCandidate(uid) {
    return httpClient.delete(`/api/recruitment/candidate?uid=${uid}`);
  },
  applyJobOffer(data) {
    return httpClient.post('/api/recruitment/candidate/membership', data);
  },
  getCandidatures(params) {
    return httpClient.get('/api/recruitment/candidate/membership', {params});
  },
  deleteCandidature(idCandidature) {
    return httpClient.delete(`/api/recruitment/candidate/membership/${idCandidature}`);
  },
  searchJobOffer(pos) {
    return httpClient.get(`/api/adv/job-offers/search/${pos.lat}/${pos.lng}/`);
  },
  getJobOffer(id) {
    return httpClient.get(`/api/adv/job-offers/${id}`);
  },
  getJobOfferID(wid) {
    return httpClient.get(`/api/between-jobs/get-job-by-wid/${wid}`)
  }
};

export default recruitmentService;
